import { Form, Input, DatePicker, InputNumber, Checkbox, Col, Row, Select, Button, message, Popconfirm, Space, Modal, Spin } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { dictsDictionary2Options, dictsGetUsers, userOptionsWithPosition } from "../../extensions/dicts";
import { productVids, salesStatuses } from "../../extensions/helper";
import { serverFetch } from "../../server";
import ClientPaymentChange from "../clients/client-payment-change";
import { LogMonitor } from "@/controls";
import { isMobile } from "@/extensions/design";

const SaleEditModal = ({ onClose, id }) => {
  const [form] = Form.useForm();
  const [users, setUsers] = useState([]);
  const [executorUsers, setExecutorUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState({ });
  const [record, setRecord] = useState();
  const [isPaymentReturn, setIsPaymentReturn] = useState(false);
  const [paymentItem, setPaymentItem] = useState({ });
  const [certificateSendModal, setCertificateSendModal] = useState(false);
  const [certificateSendEmail, setCertificateSendEmail] = useState("");


  useEffect(() => {
    dictsGetUsers(setUsers, { activeOnly: true })
  }, []);
  
  useEffect(() => {
    if (!id) return;

    setLoading(true);
    serverFetch(`sale/${id}`)
      .then(data => {
        setRecord(data);
        setItem(data);
        form.setFieldsValue({
          ...data,
          docDate: data.docDate ? dayjs(data.docDate) : null,
          activation: data.activation ? dayjs(data.activation) : null,
          finishName: data.finishName ? data.finishName : null,
        });
      })
      .catch(e => message.error(e.userMessage))
      .finally(() => setLoading(false));
  }, [id, form]);
  
  const loadExecutorUsers = (productId, vid, savedUserId) => {
    if ((vid === 1 || vid === 2 || vid === 3) && productId) {
      serverFetch("User/ProductUsersAsUsers/" + productId)
        .then(data => {
          if (data && data.length > 0) {
            const users = dictsDictionary2Options(data);
            if (savedUserId != null && !users.some(u => u.value === savedUserId)) {
              serverFetch("User/" + savedUserId)
                .then(u => {
                  if (u && u.id != null) {
                    setExecutorUsers([{ value: u.id, label: u.name, disabled: true }, ...users]);
                  } else {
                    // Фолбэк, если API не вернуло пользователя, но в record есть userName
                    const fallbackLabel = record?.userName;
                    setExecutorUsers([
                      { value: savedUserId, label: fallbackLabel, disabled: true },
                      ...users
                    ]);
                  }
                })
                .catch(e => {
                  message.error(e.userMessage);
                  // Фолбэк при ошибке запроса
                  const fallbackLabel = record?.userName;
                  setExecutorUsers([
                    { value: savedUserId, label: fallbackLabel, disabled: true },
                    ...users
                  ]);
                });
              return;
            }
            setExecutorUsers(users);
          } else {
            // Продукт без привязанных исполнителей - доступны все активные сотрудники,
            // сохранённого неактивного подгружаем отдельной карточкой
            dictsGetUsers(users => {
              if (savedUserId != null && !users.some(u => u.value === savedUserId)) {
                serverFetch("User/" + savedUserId)
                  .then(u => {
                    if (u && u.id != null) {
                      setExecutorUsers([{ value: u.id, label: u.name, disabled: true }, ...users]);
                    } else {
                      setExecutorUsers(users);
                    }
                  })
                  .catch(() => setExecutorUsers(users));
                return;
              }
              setExecutorUsers(users);
      }, { activeOnly: true });
          }
        })
        .catch(e => message.error(e.userMessage));
    } else {
      dictsGetUsers(users => {
        if (savedUserId != null && !users.some(u => u.value === savedUserId)) {
          serverFetch("User/" + savedUserId)
            .then(u => {
              if (u && u.id != null) {
                setExecutorUsers([{ value: u.id, label: u.name, disabled: true }, ...users]);
              } else {
                setExecutorUsers(users);
              }
            })
            .catch(() => setExecutorUsers(users));
          return;
        }
        setExecutorUsers(users);
      }, { activeOnly: true });
    }
  };

  useEffect(() => {
    if (record) {
      loadExecutorUsers(record.productId, record.productVid, record.userId);
    }
  }, [record]);
  
  useEffect(() => {
    if(record?.paid > 0) {
      setLoading(true);
      serverFetch(`payment/bysale/${record.id}`)
      .then((responce) => {
        const data = Array.isArray(responce) ? responce[0] : responce;

        form.setFieldsValue({
          ...responce,
          paymentDate: data?.docDate ? dayjs(data.docDate) : null,
        });
        setPaymentItem({ clientId: record.clientId, saleId: record.id, id: 0, syma: record.paid, paymentVidId: responce[responce.length - 1].paymentVidId })
        setLoading(false);
      })
      .catch((e) => {
        message.error(e.userMessage);
        setLoading(false);
      })
    }
  },[record]);

  useEffect(() => {
    setLoading(true);
    serverFetch(`sale/StatusMoveList/${id}`)
    .then((data) => {
      const nowIso = dayjs().toISOString();
      const closingRecord = data.find(item => item.status === 5 && item.docDate <= nowIso);
      form.setFieldsValue({...data, commentClose: closingRecord ? closingRecord.comment : null});
      setLoading(false);
    })
    .catch((e) => {
      message.error(e.userMessage);
      setLoading(false);
    })
  },[record]);
  
  const onCertificatePrint = () => {
    if (!record?.id) return;
    setLoading(true);
    serverFetch(`sale/CertificatePrint/${record.id}`)
      .then(data => {
        const html = data?.html;
        if (!html) {
          message.error("Не удалось получить шаблон сертификата");
          return;
        }
        const printWindow = window.open("", "_blank");
        if (!printWindow) {
          message.error("Разрешите открытие всплывающих окон для печати");
          return;
        }
        printWindow.document.open();
        printWindow.document.write(html);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
      })
      .catch(e => message.error(e.userMessage))
      .finally(() => setLoading(false));
  }

  const onOpenCertificateSend = () => {
    setCertificateSendEmail(record?.email ?? "");
    setCertificateSendModal(true);
  }

  const onCertificateSend = () => {
    if (!record?.id) return;
    setLoading(true);
    const email = certificateSendEmail.trim();
    const query = email ? `?email=${encodeURIComponent(email)}` : "";
    serverFetch(`sale/CertificateSend/${record.id}${query}`, { method: "POST" })
      .then(() => {
        message.success("Сертификат отправлен");
        setCertificateSendModal(false);
      })
      .catch(e => message.error(e.userMessage))
      .finally(() => setLoading(false));
  }

  const onValuesChange = (changedValues, allValues) => {
    let updatedValues = { ...allValues };

    if ("discountPrc" in changedValues || "price" in changedValues || "qty" in changedValues) {
      const price = allValues.price ?? 0;
      const qty = allValues.qty ?? 0;
      const discount = allValues.discountPrc ?? 0;
      const syma = (price - (price * discount / 100)) * qty;

      form.setFieldsValue({ syma });
      updatedValues.syma = syma;
    }

    setItem({ ...record, ...updatedValues });
  };

  const onSave = () => {
    setLoading(true);
    serverFetch("sale", {
      method: "PUT",
      bodyData: item,
    })
      .then(() => {
        onClose(true);
      })
      .catch((e) => {
        message.error(e.userMessage);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onDelete = () => {
    setLoading(true);
    serverFetch(`sale/${record.id}`, {
      method: "DELETE",
    })
      .then(() => {
        onClose(true);
        message.success("Реализация товара отменена успешна")
      })
      .catch((e) => {
        message.error(e.userMessage);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onReturnPayment = () => {
    setIsPaymentReturn(false);
    onClose();
  };

  const divCertificateSendModal = (
    <Modal
      title="Отправка сертификата"
      open={certificateSendModal}
      onOk={onCertificateSend}
      onCancel={() => setCertificateSendModal(false)}
      okText="Отправить"
      cancelText="Отмена"
      confirmLoading={loading}
    >
      <Input
        placeholder="Email получателя"
        value={certificateSendEmail}
        onChange={e => setCertificateSendEmail(e.target.value)}
      />
    </Modal>
  );

  if (!record) {
    return <Spin />;
  }

  return !isMobile ? (
    <Form form={form} layout="horizontal" loading={loading} colon={false} onValuesChange={onValuesChange} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} style={{marginTop:"60px"}}>
        <Row style={{marginLeft:"4px"}}>
          <Col span={4}/>
          <Col span={16} style={{marginLeft:"-13px"}}>
          <Col>
            <div className="client-item-line-double-halfed">
              <Form.Item label="Визит #" name="visitId" labelCol={{ span: 7 }} wrapperCol={{ span: 17 }}><InputNumber disabled style={{width:"70%"}}/></Form.Item>
              <Form.Item label="Клиент #" name="clientId" labelCol={{ span: 7 }} wrapperCol={{ span: 17 }}><InputNumber disabled style={{width:"70%"}}/></Form.Item>
            </div>
          </Col>
          </Col>
          <Col span={4}>
            <Form.Item name="isNew" valuePropName="checked"><Checkbox disabled>Новый</Checkbox></Form.Item>
          </Col>
        </Row>
        <Form.Item label="Клиент" name="clientName"><Input disabled/></Form.Item>
        <Row style={{marginLeft:"82px"}}>
          <Col span={10}><Form.Item label="Цена" name="price" labelCol={{ span: 9 }} wrapperCol={{ span: 15 }}><InputNumber disabled={record.paid > 0 || record.deleted} style={{width:"100%"}}/></Form.Item></Col>
          <Col span={4}><Form.Item label="Кол." name="qty" labelCol={{ span: 10 }} wrapperCol={{ span: 12 }}><InputNumber disabled={record.paid > 0 || record.deleted} min={0} style={{width:"100%"}}/></Form.Item></Col>
          <Col span={10}><Form.Item label="Сумма" name="syma" labelCol={{ span: 9 }} wrapperCol={{ span: 15 }}><InputNumber disabled style={{width:"100%"}}/></Form.Item></Col>
        </Row>
        <Row style={{marginLeft:"4px"}}>
          <Col span={14}>
            <Form.Item label="Оплачено" name="paid" labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}><InputNumber disabled style={{width:"70%"}}/></Form.Item>
          </Col>
          <Col span={10}>
            <Form.Item label="Скидка %" name="discountPrc" labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}><InputNumber disabled={record.paid > 0 || record.deleted} style={{width:"100%"}}/></Form.Item>
          </Col>
        </Row>
      <Form.Item label="Менеджер" name="managerName"><Select disabled options={users}/></Form.Item>
      <Form.Item label="Исполнитель" name="userId"><Select disabled={record.deleted || record.autoSale === 1 || (record.productVid === 0 || record.productVid === 4)} options={userOptionsWithPosition(executorUsers)} optionLabelProp="title"/></Form.Item>
      <Form.Item label="Пользователь" name="authorName"><Select disabled options={users}/></Form.Item> 
      <Form.Item label="Товар / услуга" name="productName"><Input disabled/></Form.Item>
      {record.productVid === 4 ? (
        <>
          <Form.Item label="Email" name="email"><Input disabled={record.deleted || record.activation !== null}/></Form.Item>
          <Form.Item label="Получатель" name="name"><Input disabled={record.deleted || record.activation !== null}/></Form.Item>
          <Form.Item label="Сообщение" name="message"><Input.TextArea disabled={record.deleted || record.activation !== null} autoSize={{ minRows: 2, maxRows: 5 }}/></Form.Item>
          <Form.Item label="Подпись" name="sign"><Input disabled={record.deleted || record.activation !== null}/></Form.Item>
          <Form.Item label="Комм. закр." name="commentClose"><Input disabled={true}/></Form.Item>
        </>
      ) : null}
        <Row style={{marginLeft:"20px"}}>
          <Col span={13}>
            <Form.Item label="Дата" name="docDate" labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}><DatePicker disabled format="DD.MM.YYYY" style={{width:"75%"}}/></Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item label="Продажа" name="paymentDate" labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}><DatePicker disabled format="DD.MM.YYYY" style={{width:"100%"}}/></Form.Item>
          </Col>
        </Row>
        <Row style={{marginLeft:"20px"}}>
          <Col span={13}>
            { record?.productVid !== 4 ? (
              <Form.Item label="Активация" name="activation" labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}>
                <DatePicker disabled format="DD.MM.YYYY" style={{width:"75%"}}/>
              </Form.Item> ) : (
              <Form.Item label="Активация" name="paymentDate" labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}>
                <DatePicker disabled format="DD.MM.YYYY" style={{width:"75%"}}/>
              </Form.Item> )
            }
          </Col>
          <Col span={11}>
            <Form.Item label="Окончание" name="finishName" labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}><Input disabled format="DD.MM.YYYY" style={{width:"100%", maxHeight:"32px"}}/></Form.Item>
          </Col>
        </Row>
        <Row style={{marginLeft:"20px"}}>
          <Col span={13}>
            <Form.Item label="Статус" name="status" labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}><Select disabled options={salesStatuses} style={{width:"75%"}}/></Form.Item>  
          </Col>
          <Col span={6}/>
          <Col span={5}>
            <Form.Item name="deleted" valuePropName="checked"><Checkbox disabled>Удален</Checkbox></Form.Item>
          </Col>
        </Row>
      <Form.Item label=" ">
        <Space>
          <Button className="sport-btn-wide" onClick={() => {onSave()}} disabled={record.deleted}>Сохранить</Button>
          <Button className="sport-btn-wide" disabled={record.paid === 0} onClick={() => {setIsPaymentReturn(!isPaymentReturn)}}>Возврат</Button>
          <Popconfirm title="Подтверждение" description={!record.deleted ? "Вы действительно хотите удалить продажу?" : "Вы действительно хотите отменить удаление?"} onConfirm={onDelete}>
            <Button className="sport-btn-wide">Удалить</Button>
          </Popconfirm>
          <LogMonitor vid={4} id={record?.id}/>
          <Button className="sport-btn-wide" onClick={() => onClose(false)}>Закрыть</Button>
        </Space>
      </Form.Item>
      <Form.Item label=" ">
        {record.productVid === 4 ? 
          <Space>
            <Button disabled={record.deleted} onClick={onCertificatePrint}>Печать сертификата</Button>
            <Button disabled={record.deleted} onClick={onOpenCertificateSend}>Отправить сертификат</Button>
          </Space> : <></>}
      </Form.Item>
      <div style={{marginTop:"16px"}}>
        {isPaymentReturn && <ClientPaymentChange paymentItem={{ ...paymentItem, vid: -1, docDate: dayjs() }}
        onClose={() => {onClose(false)}} isAbon={false}></ClientPaymentChange>}
      </div>
      {divCertificateSendModal}
    </Form>
  ) : (
    <>
      <Form form={form} layout="inline" loading={loading} colon={false} onValuesChange={onValuesChange} labelCol={{ xs: 6 }} wrapperCol={{ xs: 18 }}>
        <Form.Item className="records-form-item-mobile" label="Визит">
          <Row align="middle" className="records-row-mobile">
            <Col>
              <Form.Item name="visitId">
                <InputNumber disabled className="sales-numbers-input-mobile"/>
              </Form.Item>
            </Col>
            <Col>
              <Form.Item label="Клиент" name="clientId" labelCol={{ span: 2 }} wrapperCol={{ span: 7 }}>
                <InputNumber disabled className="sales-numbers-input-mobile"/>
              </Form.Item>
            </Col>
            <Col>
              <Form.Item label="Нов." name="isNew" valuePropName="checked" labelCol={{ span: 1 }} wrapperCol={{ span: 7 }}>
                <Checkbox disabled/>
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item className="record-form-item-with-margin-top-mobile" label="Клиент" name="clientName">
          <Input disabled className="records-form-item-mobile"/>
        </Form.Item>

        <Form.Item className="records-form-item-mobile" label="Цена">
          <Row align="middle" className="records-row-mobile">
            <Col>
              <Form.Item name="price" className="record-form-item-with-margin-top-mobile">
                <InputNumber disabled={record.paid > 0 || record.deleted} className="sales-numbers-input-mobile"/>
              </Form.Item>
            </Col>
            <Col>
              <Form.Item label="Кол." name="qty" labelCol={{ span: 1 }} className="record-form-item-with-margin-top-mobile">
                <InputNumber disabled={record.paid > 0 || record.deleted} min={0} className="sales-numbers-input-mobile"/>
              </Form.Item>
            </Col>
            <Col>
              <Form.Item label="Сум." labelCol={{ span: 1 }} name="syma" className="record-form-item-with-margin-top-mobile">
                <InputNumber disabled className="sales-numbers-input-mobile"/>
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>

        <Form.Item className="records-form-item-mobile" label="Оплачено">
          <Row align="middle" className="records-row-mobile">
            <Col>
              <Form.Item name="paid" className="record-form-item-with-margin-top-mobile">
                <InputNumber disabled className="records-small-input-mobile"/>
              </Form.Item>
            </Col>
            <Col>
              <Form.Item label="Скидка %" name="discountPrc" className="record-form-item-with-margin-top-mobile">
                <InputNumber disabled={record.paid > 0 || record.deleted} className="records-small-input-mobile"/>
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item label="Менеджер" name="managerName" className="record-form-item-with-margin-top-mobile">
          <Select disabled options={users} className="records-form-item-mobile"/>
        </Form.Item>
        <Form.Item label="Исполнит." name="userId" className="record-form-item-with-margin-top-mobile">
          <Select disabled={record.deleted || record.autoSale === 1 || (record.productVid === 0 || record.productVid === 4)} options={userOptionsWithPosition(executorUsers)} optionLabelProp="title" className="records-form-item-mobile"/>
        </Form.Item>
        <Form.Item label="Пользоват." name="authorName" className="record-form-item-with-margin-top-mobile">
          <Select disabled options={users} className="records-form-item-mobile"/>
        </Form.Item> 
        <Form.Item label="Товар/услуг." name="productName" className="record-form-item-with-margin-top-mobile">
          <Input disabled className="records-form-item-mobile"/>
        </Form.Item>
        {record.productVid === 4 ? (
          <>
            <Form.Item label="Email" name="email" className="record-form-item-with-margin-top-mobile">
              <Input disabled={record.deleted || record.activation !== null} className="records-form-item-mobile"/>
            </Form.Item>
            <Form.Item label="Получат." name="name" className="record-form-item-with-margin-top-mobile">
              <Input disabled={record.deleted || record.activation !== null} className="records-form-item-mobile"/>
            </Form.Item>
            <Form.Item label="Сообщ." name="message" className="record-form-item-with-margin-top-mobile">
              <Input.TextArea disabled={record.deleted || record.activation !== null} className="records-form-item-mobile" autoSize={{ minRows: 2, maxRows: 5 }}/>
            </Form.Item>
            <Form.Item label="Подпись" name="sign" className="record-form-item-with-margin-top-mobile">
              <Input disabled={record.deleted || record.activation !== null} className="records-form-item-mobile"/>
            </Form.Item>
            <Form.Item label="Комм.закр." className="record-form-item-with-margin-top-mobile" name="commentClose">
              <Input disabled={true}/>
            </Form.Item>
          </>
        ) : null}
        <Form.Item className="records-form-item-mobile" label="Дата">
          <Row align="middle" className="records-row-mobile">
            <Col>
              <Form.Item name="docDate" wrapperCol={{ span: 7}} className="record-form-item-with-margin-top-mobile">
                <DatePicker disabled format="DD.MM.YYYY" className="sales-small-input-mobile"/>
              </Form.Item>
            </Col>
            <Col>
              <Form.Item label="Прод." labelCol={{ span: 2 }} wrapperCol={{ span: 7}} name="paymentDate" className="record-form-item-with-margin-top-mobile">
                <DatePicker disabled format="DD.MM.YYYY" className="sales-small-input-mobile"/>
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item className="records-form-item-mobile" label="Активация">
          <Row align="middle" className="records-row-mobile">
            <Col>
            { record.productVid !== 4 ? (
              <Form.Item name="activation" className="record-form-item-with-margin-top-mobile">
                <DatePicker disabled format="DD.MM.YYYY" className="sales-small-input-mobile"/>
              </Form.Item> ) : (
              <Form.Item name="paymentDate" className="record-form-item-with-margin-top-mobile">
                <DatePicker disabled format="DD.MM.YYYY" className="sales-small-input-mobile"/>
              </Form.Item> )
            }
            </Col>
            <Col>
              <Form.Item label="Оконч." name="finishName" labelCol={{ span: 2 }} className="record-form-item-with-margin-top-mobile">
                <Input disabled format="DD.MM.YYYY" className="sales-small-input-mobile" style={{maxHeight: "32px"}}/>
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item className="records-form-item-mobile" label="Статус">
          <Row align="middle" className="records-row-mobile">
            <Col>
              <Form.Item name="status" className="record-form-item-with-margin-top-mobile">
                <Select disabled options={salesStatuses} className="records-form-item-mobile"/>
              </Form.Item>
            </Col>
            <Col>
              <Form.Item label="Удал." name="deleted" valuePropName="checked" labelCol={{ span: 1 }} className="record-form-item-with-margin-top-mobile">
                <Checkbox disabled/>
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
      </Form>
      <div className="sales-buttons-line-triple-halfed" style={{marginTop: "4px"}}>
        <Button onClick={() => {onSave()}} disabled={record.deleted}>Сохранить</Button>
        <Button disabled={record.paid === 0} onClick={() => {setIsPaymentReturn(!isPaymentReturn)}}>Возврат</Button>
        <Popconfirm title="Подтверждение" description={!record.deleted ? "Вы действительно хотите удалить продажу?" : "Вы действительно хотите отменить удаление?"} onConfirm={onDelete}
          placement="top" getPopupContainer={(trigger) => trigger.closest('.sales-buttons-line-triple-halfed')} overlayClassName="centered-popconfirm">
          <Button>Удалить</Button>
        </Popconfirm>
      </div>
      {record.productVid === 4 ? 
        <Space style={{marginTop: 4, display: "flex", justifyContent: "center"}}>
          <Button disabled={record.deleted} onClick={onCertificatePrint}>Печать серт.</Button>
          <Button disabled={record.deleted} onClick={onOpenCertificateSend}>Отправка серт.</Button>
        </Space> : <></>
      }
      { isPaymentReturn &&
        <ClientPaymentChange paymentItem={{ ...paymentItem, vid: -1, docDate: dayjs() }}
          onClose={() => {onReturnPayment()}} isAbon={false} isModal={true}></ClientPaymentChange>}
      {divCertificateSendModal}
    </>
  );
};

export default SaleEditModal;
